import { render } from "./vertical_space.vue?vue&type=template&id=4538b0b3"
import script from "./vertical_space.vue?vue&type=script&lang=js"
export * from "./vertical_space.vue?vue&type=script&lang=js"

import "./vertical_space.vue?vue&type=style&index=0&id=4538b0b3&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__